/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconSocialShare = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M3.545 7.256C3.825 6.912 4 6.479 4 6a2 2 0 1 0-2 2c.263 0 .512-.053.743-.146l2.366 2.959a.5.5 0 0 0 .782-.625L3.545 7.256zM8 1a1.995 1.995 0 1 0-.5 3.929V9.5a.5.5 0 0 0 1 0V4.929A1.995 1.995 0 0 0 8 1zM8 11a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 11zM14 4a2 2 0 0 0-2 2c0 .478.175.911.455 1.256l-2.346 2.931A.502.502 0 0 0 10.5 11a.5.5 0 0 0 .391-.188l2.366-2.958A2 2 0 1 0 14 4z"
    />
  </svg>
);

IconSocialShare.displayName = 'IconSocialShare';

IconSocialShare.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconSocialShare);
IconSocialShare.displayName = 'IconSocialShare';
